export const sectionIds = {
  hero: "hero",
  whyUs: "why-us",
  methodology: "methodology",
  contact: "contact",
};

export function scrollToSection(section, options = {}) {
  const target = document.getElementById(section);
  if (!target) return;

  target.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function scrollToTop(options = {}) {
  window.scrollTo({ top: 0, behavior: "smooth" });
}
